/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  serviceId: ZodTypes.Id,
});

export const UserFavoriteServicePut = {
  id: 'user.favorite-service.put',
  tag: 'User',
  summary: 'Add a Service to Favorites',
  description: 'Adds a specific service to the user’s favorites',
  method: 'put',
  flags: { isAuthorized: true },
  route: (args: z.infer<typeof Params>) => `/user/favorite/service/${args.serviceId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'Service successfully added to favorites',
      content: {
        'application/json': {
          schema: z.object({ success: z.boolean() }),
        },
      },
    },
  },
} as const satisfies Endpoint;
